import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, XCircle, Info, AlertCircle, X } from 'lucide-react';
export type ToastType = 'success' | 'error' | 'info' | 'warning';
interface ToastProps {
  message: string;
  type: ToastType;
  isVisible: boolean;
  onClose: () => void;
  duration?: number;
}
export function Toast({
  message,
  type,
  isVisible,
  onClose,
  duration = 5000
}: ToastProps) {
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);
  const icons = {
    success: <CheckCircle size={24} className="text-green-500" data-id="element-260" />,
    error: <XCircle size={24} className="text-red-500" data-id="element-261" />,
    info: <Info size={24} className="text-blue-500" data-id="element-262" />,
    warning: <AlertCircle size={24} className="text-yellow-500" data-id="element-263" />
  };
  const backgrounds = {
    success: 'bg-green-50 border-green-200',
    error: 'bg-red-50 border-red-200',
    info: 'bg-blue-50 border-blue-200',
    warning: 'bg-yellow-50 border-yellow-200'
  };
  return <AnimatePresence data-id="element-264">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: -50,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: -50,
      scale: 0.95
    }} className="fixed top-4 right-4 z-50 max-w-md" data-id="element-265">
          <div className={`${backgrounds[type]} border rounded-lg shadow-lg p-4 flex items-start gap-3`} data-id="element-266">
            {icons[type]}
            <p className="flex-1 text-charcoal font-medium" data-id="element-267">{message}</p>
            <button onClick={onClose} className="text-stone hover:text-charcoal transition-colors" data-id="element-268">
              <X size={20} data-id="element-269" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}